import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { URL, PAGINA_HOME, PAGINA_LOGIN, PAGINA_HOME_USUARIO_INTERNO, montarUrlDoCliente } from 'src/app/tools/URL';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakLoginOptions } from 'keycloak-js';
import {
  AppAuthService,
  EMAIL_LOOKUP_ERROR_KEY,
  EMAIL_LOOKUP_INTERNAL_ERROR,
  EMAIL_LOOKUP_JDBC_ERROR,
  EMAIL_REQUIRED_LOGOUT_KEY
} from 'src/app/service/auth/auth.service';
import {
  ERRO_AUTENTICACAO_CAPTCHA,
  ERRO_FORMATO_EMAIL_INVALIDO,
  ERRO_SENHA_OBRIGATORIA,
  ERRO_LOGIN_OBRIGATORIO } from 'src/app/tools/Mensagens';
import { environment } from 'src/app/environment';
import { HttpClient } from '@angular/common/http';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { build } from 'src/build/build';

const JWT_TOKEN_KEY = 'AuthToken';
const CURRENT_USER = 'CurrentUser';
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const EMAIL_REQUIRED_MESSAGE = 'Para prosseguir, efetue o login por meio do portal GOV.BR ou utilize o login e a senha vinculados ao Canal Fale com o TJMG';
const EMAIL_LOOKUP_JDBC_MESSAGE = 'Foi identificado indisponibilidade no serviço de validação da conta, favor tente novamente mais tarde';
const EMAIL_LOOKUP_INTERNAL_MESSAGE = 'Não foi possível concluir operação interna no servidor';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  myRecaptcha = new FormControl(false);
  email = '';
  senha = '';
  urlHome = PAGINA_HOME;
  url = PAGINA_HOME;
  urlEsqueciMinhaSenha = URL.ESQUECI_SENHA_EMAIL;
  urlRedefinirSenha = URL.REDEFINIR_SENHA_EMAIL;
  urlUsuario = URL.USUARIO;
  urlDenuncia = URL.DENUNCIA;
  exibirMensagemEmail = false;
  mensagemEmail = EMAIL_REQUIRED_MESSAGE;
  tipoMensagemEmail = 'info';

  modalRef: BsModalRef | null = null;

  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    protected keycloakService: KeycloakService,
    private http: HttpClient,
    public modalService: BsModalService,
    private appAuth: AppAuthService) { }


  ngOnInit() {
    try {
      const erroObtencaoEmail = sessionStorage.getItem(EMAIL_LOOKUP_ERROR_KEY);
      if (erroObtencaoEmail === EMAIL_LOOKUP_JDBC_ERROR) {
        this.mensagemEmail = EMAIL_LOOKUP_JDBC_MESSAGE;
        this.tipoMensagemEmail = 'error';
        this.exibirMensagemEmail = true;
      } else if (erroObtencaoEmail === EMAIL_LOOKUP_INTERNAL_ERROR) {
        this.mensagemEmail = EMAIL_LOOKUP_INTERNAL_MESSAGE;
        this.tipoMensagemEmail = 'error';
        this.exibirMensagemEmail = true;
      } else {
        this.mensagemEmail = EMAIL_REQUIRED_MESSAGE;
        this.tipoMensagemEmail = 'info';
        this.exibirMensagemEmail = sessionStorage.getItem(EMAIL_REQUIRED_LOGOUT_KEY) === 'true';
      }
    } catch (e) {
      this.exibirMensagemEmail = false;
    }
    if (this.authService.isUsuarioExternoLogado()) {
      this.router.navigate([PAGINA_HOME]);
      return;
    }

    this.keycloakService.isLoggedIn().then(logado => {
      if (logado) {
        this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);
        return;
      }
    });

    this.activatedRoute.queryParamMap.subscribe(params => {
      this.url = params.get('url') || this.url;
      this.authService.definirRedirecionamentoGovBr(this.url);
    });
  }

  validateLogin(email: string, senha: string, myRecaptcha: FormControl) {

    if (!myRecaptcha.value) {

      alert(ERRO_AUTENTICACAO_CAPTCHA);

      return false;

    }

    if (email === null || email === '') {

      alert(ERRO_LOGIN_OBRIGATORIO);

      return false;

    }

    if (!EMAIL_REGEX.test(email)) {

      alert(ERRO_FORMATO_EMAIL_INVALIDO);

      return false;

    }

    if (senha === null || senha === '') {

      alert(ERRO_SENHA_OBRIGATORIA);

      return false;

    }

    return true;

  }

  logar() {
    this.limparMensagemEmail();

    if (this.validateLogin(this.email.trim(), this.senha, this.myRecaptcha)) {

      this.authService.login(this.email.trim(), this.senha, this.url);

    }

  }

  keycloakLogin() {

    this.limparMensagemEmail();

    // Build the same redirect used previously (clientWebUrl + /usuario-interno)
    const redirectUri = montarUrlDoCliente(environment.settings.clientWebUrl, URL.USUARIO_INTERNO);

    const loginOptions: KeycloakLoginOptions = {
      redirectUri
    };

    this.keycloakService.login(loginOptions);
    localStorage.removeItem(JWT_TOKEN_KEY);
    localStorage.removeItem(CURRENT_USER);

    // Use the angular-oauth2-oidc service to start the Authorization Code + PKCE flow
    // This will redirect the browser to the Keycloak authorize endpoint configured in AppAuthService
    try {
      // Force prompt=login so Keycloak displays the login page (avoid prompt=none or broker auto-login)
      this.appAuth.loginWithRedirect(redirectUri, { prompt: 'login' });
    } catch (e) {
      console.error('Erro ao iniciar fluxo OIDC', e);
      // Fallback: try using old keycloak adapter if available
      const loginOptions: KeycloakLoginOptions = {
        redirectUri
      };
      this.keycloakService.login(loginOptions);
    }

  }



  loginUnicoGovBr() {

    this.limparMensagemEmail();

    // Remove artefatos do fluxo OIDC interno para que eles não capturem nem
    // invalidem o code/state devolvido pelo Gov.br.
    try {
      sessionStorage.removeItem('oidc_flow_started');
      sessionStorage.removeItem('oidc_callback_code');
      sessionStorage.removeItem('oidc_callback_state');
      sessionStorage.removeItem('oidc_callback_iss');
      sessionStorage.removeItem('oidc_code_verifier');
      sessionStorage.removeItem('oidc_state');
      sessionStorage.removeItem('oidc_nonce');
      sessionStorage.removeItem('oidc_redirect_uri');
    } catch (e) {
      // O redirecionamento ainda deve ocorrer caso o storage esteja indisponível.
    }

    // Defina as informações da autorização
    const response_type = 'code'; //Especifica para o provedor o tipo de autorização. Neste caso será code
    const client_id = build.client_id_gov_br; //Chave de acesso, que identifica o serviço consumidor fornecido pelo Login Único para a aplicação cadastrada
    const scope = 'openid+email+profile'; // Especifica os recursos que o serviço consumidor quer obter. Um ou mais escopos inseridos para a aplicação cadastrada. Informação a ser preenchida por padrão: openid+email+profile+govbr_confiabilidades.
    const redirect_uri = build.redirect_uri_gov_br;
    const nonce = '7dr9db20gcrc'; //Sequência de caracteres usado para associar uma sessão do serviço consumidor a um Token de ID e para atenuar os ataques de repetição. Pode ser um valor aleatório, mas que não seja de fácil dedução. Item obrigatório.
    const redirecionamentoPosLogin = this.authService.definirRedirecionamentoGovBr(this.url);
    const state = encodeURIComponent(redirecionamentoPosLogin); //Valor usado para manter o estado entre a solicitação e o retorno de chamada.
    const code_challenge = 'iIOnIS82PWKZPJ6OxwfcAEsq_HDXRaAqm-DdFSWlUpg'; //Senha gerada pelo cliente para proteger o code da requisicao do Authorize. Seguir o padrão BASE64URL-ENCODE(SHA256(ASCII(Valor da Atributo do code_verifier a ser utilizado no /Token))).
    const code_challenge_method = 'S256'; //Será o método para proteger a senha enviada no parâmetro code_challenge. O padrão será «S256».
    const url_acesso = build.url_acesso_gov_br;

    // Montar a URL de redirecionamento para o Gov.br
  const safeRedirect = redirect_uri || '';
  const authorizeUrl = `${url_acesso}/authorize?response_type=${response_type}&client_id=${client_id}&scope=${scope}&redirect_uri=${encodeURIComponent(safeRedirect)}&nonce=${nonce}&state=${state}&code_challenge=${code_challenge}&code_challenge_method=${code_challenge_method}`;

    //Redirecionar para a URL de autorização
    window.location.href = authorizeUrl;

   }

  limparMensagemEmail(): void {
    this.exibirMensagemEmail = false;
    this.mensagemEmail = EMAIL_REQUIRED_MESSAGE;
    this.tipoMensagemEmail = 'info';
    try {
      sessionStorage.setItem(EMAIL_REQUIRED_LOGOUT_KEY, 'null');
      sessionStorage.setItem(EMAIL_LOOKUP_ERROR_KEY, 'null');
    } catch (e) {}
  }

  denunciaAnonimaAviso() {
    this.router.navigate([URL.DENUNCIA_ANONIMA_AVISO]);
  }

  denunciaAnonimaAcompanhamento() {
    this.router.navigate([URL.DENUNCIA_ANONIMA_ACOMPANHAMENTO]);
  }

  // Método que realiza a abertura do modal, caso as validações sejam aceitas. Caso contrário, será apresentado apenas mensagem de erro.
  openModalPopUp(template: TemplateRef<any>) {



    // Chamada usando o proprio componente - ERRRO - Não esta identificando o template
    //this.modalRef = this.modalService.show(ConfirmWindowComponent, {class: 'modal-sm'});
    // Chamada usando o componente já estabelecido no denuncia.component.html (OK)
    //this.modalRef = this.modalService.show(template, {class: 'modal-sm'});
    this.modalRef = this.modalService.show(template, {
      class: 'modal-sm',
      initialState: {
        // Outras propriedades iniciais do modal
      },
      backdrop: 'static', // opcional, para impedir que o modal seja fechado ao clicar fora dele
      animated: true // opcional, para adicionar uma animação ao abrir o modal
    });

  }

  decline(): void {

  if (this.modalRef) {
    this.modalRef.hide();
  }
  this.router.navigate([PAGINA_LOGIN], { queryParams: { url: this.urlDenuncia } });

  }

}
